var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('router-link',{attrs:{"to":`/systemuser/kartei/${_vm.model.id}`}},[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }